export default "__VITE_ASSET__7913fb94__"